import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import validator from 'utils/validator';
import produce from 'utils/produce';
import { Container, Form, Typography, Card, Button } from 'components/base';

import useEditorContext from '../context/editorContext';
import DesignSelect from '../components/designSelect';
import { getPageAssetUrl } from 'editor-utils/template';

const ADDITIONAL_INFO = {
  sender_name: {
    label: 'Who is it from?',
    placeholder: 'Gift giver’s name',
    type: 'text',
    isValid: value => value.length > 1,
  },
  recipient_name: {
    label: 'Who is it for?',
    placeholder: 'Recipient’s name',
    type: 'text',
    isValid: value => value.length > 1,
  },
  recipient_email: {
    label: 'Where should we send it?',
    placeholder: 'Recipient’s email',
    type: 'email',
    isValid: value => validator.isEmailValid(value),
  },
  message: {
    label: 'Gift Message',
    placeholder: 'Enter your message here. (Optional)',
    type: 'textarea',
    isValid: () => true,
  },
};

const CouponEditor = props => {
  const editorContext = useEditorContext();

  const [finished, setFinished] = useState(false);

  const { pages, additionalInfo } = props.item;

  useEffect(() => {
    const { additional_info_requires: additionalInfoRequires } = props.template.template;

    const newAdditionalInfo = {};
    if (additionalInfoRequires) {
      additionalInfoRequires.forEach(field => {
        newAdditionalInfo[field] = additionalInfo[field] || '';
      });
    }

    editorContext.setAdditionalInfo(props.item.id, newAdditionalInfo);
  }, [props.template]);

  useEffect(() => {
    if (pages.length === 0 && props.template.pages) {
      editorContext.setPages(props.item.id, [{ id: props.template.pages[0].id }]);
    }
  }, [props.template, pages]);

  const handleOnChangeDesign = id => {
    editorContext.setPages(props.item.id, [{ id }]);
  };

  const handleOnChangeValue = (key, value) => {
    editorContext.setAdditionalInfo(
      props.item.id,
      produce(additionalInfo, draft => {
        draft[key] = value;
      }),
    );
  };

  const handleOnAddToCartClick = e => {
    e.preventDefault();
    setFinished(true);

    const data = {
      additional_info: additionalInfo,
      pages: pages.length > 0 ? pages : undefined,
    };

    const errors = [];
    Object.keys(additionalInfo).forEach(key => {
      if (!ADDITIONAL_INFO[key].isValid(additionalInfo[key])) {
        errors.push('Please fill in all required fields.');
      }
    });

    if (errors.length > 0) {
      editorContext.toast(errors[0], { type: 'warning' });
    } else {
      props.onFinish(data);
    }
  };

  return (
    <Container className="editor-coupon">
      {(props.template.pages || []).length > 0 && pages.length > 0 && (
        <DesignSelect
          title="PICK A DESIGN"
          active={pages[0].id}
          onChange={handleOnChangeDesign}
          items={props.template.pages.map(page => ({
            key: page.id,
            icon: getPageAssetUrl(props.template, page.id),
          }))}
          className="design-select-coupon"
        />
      )}

      <Form className="mx-auto mw-480">
        {Object.entries(additionalInfo).map(([key, value]) => {
          const field = ADDITIONAL_INFO[key];

          return (
            <Form.Group key={key}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Input
                type={field.type}
                onChange={e => handleOnChangeValue(key, e.target.value)}
                placeholder={field.placeholder}
                value={value}
                isInvalid={finished && !field.isValid(value)}
              />
            </Form.Group>
          );
        })}
      </Form>

      <Card className="text-center mx-auto mw-480 mb-3">
        <Card.Body>
          <Typography.H4 className="text-warning">ALL FINISHED?</Typography.H4>
          <Typography.P className="mb-1">Proceed and add product into your cart!</Typography.P>
          <Button block type="success" onClick={handleOnAddToCartClick}>
            Add to Cart
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

CouponEditor.propTypes = {
  item: PropTypes.object,
  product: PropTypes.object,
  template: PropTypes.object,
  onFinish: PropTypes.func,
};

export default CouponEditor;
